import React, { useState, useRef, useEffect, useContext } from "react";
import Box from "@mui/material/Box";
import PropTypes from "prop-types";
import Toolbar from "@mui/material/Toolbar";
import AppBar from "@mui/material/AppBar";
import DashboardAllProjects from "./DashboardAllProjects_tm";
import DashboardAllProjects_ff from "./DashboardAllProjects_ff";
import GanttChartContainer from "./GanttChartContainer";
import RequirementsContainer from "./RequirementsContainer";
//import Discussion from "./Discussion";
import Discussion from "./ProjectDiscussion";
import ChangeLogContainer from "./ChangeLogContainer";
import Button from "@mui/material/Button";
import CredentialsPage from "./CredentialsPage";
import IconButton from "@mui/material/IconButton";
import SettingsIcon from "@mui/icons-material/Settings";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import SettingsContainer from "./SettingsContainer";
import GlobalData from "./GlobalData";
import RAIDContainer from "./RAIDContainer";
import BlankScreen from "./BlankScreen";
import Tools from "./JNSTools";
import Alert from "@mui/material/Alert";
import TLDrawComponent from "./TLDrawComponent";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import Stack from "@mui/material/Stack";
import DvrIcon from "@mui/icons-material/Dvr";
import SegmentIcon from "@mui/icons-material/Segment";
import MessageIcon from "@mui/icons-material/Message";
import ListIcon from "@mui/icons-material/List";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import ChangeCircleIcon from "@mui/icons-material/ChangeCircle";
import InvoiceBulkSendContainer from "./InvoiceBulkSendContainer";
import DashboardIcon from "@mui/icons-material/Dashboard";
import LockIcon from "@mui/icons-material/Lock";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import AddCardIcon from "@mui/icons-material/AddCard";
import { HelpModeContext } from "./Contexts";
import TimeEntry from "./TimeEntry";
import DashboardSingleProject_nogrid from "./DashboardSingleProject_nogrid";
import CustomAlert from "./CustomAlert";
import Popper from "@mui/material/Popper";
import Slide from "@mui/material/Slide";
import "./styles/MainToolbar.css";

//import { registerLicense } from "@syncfusion/ej2-base";

function CollaborationCompanionToolbar(props) {
  let creds = props.creds;
  let tempSettings;
  const settingsPage = useRef();
  const [open, setOpen] = useState(false);
  const projid = useRef();
  const projname = useRef();
  const discussion = useRef();
  const metrics = useRef();
  const selectedTab = useRef(0);
  const selectedRaidSubTab = useRef(0);
  const selectedCommSubTab = useRef(0);
  const projectObject = useRef();
  const redirected = useRef(false);
  const pages = useRef([]);
  let projectListButtons = [];
  const raidSubPages = useRef([]);
  const commSubPages = useRef([]);
  const [dashboardsetuplocked, setDashboardSetupLocked] = useState(false);
  const [showNoFavoritesDialog, setShowNoFavoritesDialog] = useState(false);
  const [showAddPanel, setShowAddPanel] = useState(false);
  const projectList = useRef("button0");
  const loadedSettings = JSON.parse(localStorage.getItem("oadaSettings"));
  const helpMode = useContext(HelpModeContext).mode;
  const [openAlert, setOpenAlert] = useState(false);
  const [panelsLocked, setPanelsLocked] = useState(true);
  const [addPanelAnchorElem, setAddPanelAnchorElem] = useState(null);
  const errorMessage = useRef();
  const containerRef = useRef(null);
  // Registering Syncfusion license key
  //registerLicense(
  //  "ORg4AjUWIQA/Gnt2VlhhQlJCfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hSn9Sd0NjXntWc3JTQGhf",
  //);

  if (creds.modules === undefined) {
    creds.modules = [];
  }
  const queryParameters = new URLSearchParams(window.location.search);

  queryParameters.forEach((value, key) => {
    if (key == "target" && !redirected.current) {
      if (value == "Requirements") {
        if (sessionStorage.getItem("projectObject")) {
          projectObject.current = JSON.parse(
            sessionStorage.getItem("projectObject"),
          );
          redirected.current = true;
          setTarget("Requirements");
        }
      }
    }
  });

  const handleClick = (event) => {
    let executeButton = true;
    let buttonClicked =
      event.target.textContent == "" && event.target.id == "Login"
        ? "Login"
        : event.target.textContent
          ? event.target.textContent
          : event.currentTarget.value;
    if (buttonClicked.substring(0, 6) == "PANELS") {
      buttonClicked = "Whiteboard";
    }
    if (event.target.id == "Login") {
      executeButton = confirm(
        "Click OK to return to the login screen, or Cancel to stay on this screen",
      );
    }

    if (executeButton) {
      setTarget(buttonClicked);
    }
  };

  if (selectedTab.current == 0) {
    pages.current = [];
    projectListButtons = ["Time and Materials Projects", "Fixed Fee Projects"];
  } else {
    projectListButtons = [];
  }

  async function prepDisplay(adminCreds) {
    props.waitHandler(true, "Loading settings, project list...");
    let validLogin = true;
    const globalData = new GlobalData(adminCreds);
    globalData.populateTable("User").then((users) => {
      if (users) {
        const userRec = users.find(
          (usersElem) =>
            usersElem.nickname.toLowerCase() == creds.username.toLowerCase(),
        );
        if (userRec) {
          creds.id = userRec.id;
          creds.role = userRec.role;
          creds.modules = userRec.modules
            ? userRec.modules.replace(/"/g, "").split(",")
            : [
                "Dashboard",
                "Gantt Chart",
                "Messages",
                "RAID",
                "Requirements",
                "Change Log",
              ];
          localStorage.setItem(
            "instanceInfo",
            Tools.encrypt(JSON.stringify(creds)),
          );

          if (creds.userType == "generic") {
            if (userRec.genericPassword != creds.password) {
              validLogin = false;
            }
          }
        }
      }

      if (validLogin) {
        sessionStorage.setItem("sessionId", "");
        const authString = Tools.getXmlBodyRemoteAuthString(creds);
        const urlString = Tools.getInstanceUrl(creds);

        const requestString =
          authString +
          '<Read type="Company" method="all" limit="1"></Read></request>';
        Tools.fetchPost(requestString, urlString, "Flag").then((flagXML) => {
          try {
            if (flagXML.xml.length > 0) {
              const flagRecords = Tools.xmlToArray(flagXML.xml);
              const bookingFlag = flagRecords.find(
                (elem) => elem.name == "rm_booking_project_task", // used to be require_rm_pt
              ).setting;
              sessionStorage.setItem("bookingByTask", bookingFlag == "1");
              const pctCompleteReadOnly = flagRecords.find(
                (elem) => elem.name == "pm_percent_complete_ro",
              ).setting;
              sessionStorage.setItem(
                "pctCompleteReadOnly",
                pctCompleteReadOnly == "1",
              );
            }
          } catch (e) {
            if (flagXML.xml) {
              errorMessage.current = "Error in CCToolbar: " + e.message;
              setOpenAlert(true);
            }
          }
        });
      } else {
        errorMessage.current = "Incorrect password.  Please try again.";
        setOpenAlert(true);
      }
    });

    if (validLogin) {
      props.retrieveOADASettings().then((credsWithClient) => {
        creds = credsWithClient;
        let target = "Projects";
        setTarget(target);
      });
    }
  }

  const handleSave = (newTarget) => {
    setOpen(false);
    settingsPage.current = undefined;

    if (tempSettings) {
      localStorage.setItem("oadaSettings", JSON.stringify(tempSettings));
    }

    // newTarget will be an event if it isn't specified in the call, otherwise it'll be a string
    if (typeof newTarget == "string") {
      setTarget(newTarget);
    } else {
      const previousTab = sessionStorage.getItem("currentTab");
      setTarget(previousTab);
    }

    // full browser refresh called to ensure toolbar refreshes also
    //window.location.reload();
  };

  const handleCancel = (newTarget) => {
    setOpen(false);
    // newTarget will be an event if it isn't specified in the call, otherwise it'll be a string
    if (typeof newTarget == "string") {
      setTarget(newTarget);
    } else {
      const previousTab = sessionStorage.getItem("currentTab");
      setTarget(previousTab);
    }
  };

  const refreshDashboard = (
    tab,
    projid_param,
    projname_param,
    discussion_param,
    metrics_param,
    projObject,
  ) => {
    projid.current = projid_param;
    projname.current = projname_param;
    discussion.current = discussion_param;
    metrics.current = metrics_param;
    projectObject.current = projObject;

    sessionStorage.setItem(
      "projectObject",
      JSON.stringify(projectObject.current),
    );

    if (projid.current) {
      pages.current = [
        { name: "Projects", icon: <DvrIcon fontSize="small" /> },
      ];

      //if (creds.userType == "regular") {

      if (creds.modules.indexOf("Dashboard") >= 0) {
        pages.current.push({
          name: "Dashboard",
          icon: <DashboardIcon fontSize="small" />,
        });
      }
      if (creds.modules.indexOf("Gantt Chart") >= 0) {
        pages.current.push({
          name: "Gantt",
          icon: <SegmentIcon fontSize="small" />,
        });
      }
      if (creds.modules.indexOf("Messages") >= 0) {
        pages.current.push({
          name: "Messages",
          icon: <MessageIcon fontSize="small" />,
        });
      }
      if (creds.modules.indexOf("RAID") >= 0) {
        pages.current.push({
          name: "RAID",
          icon: <ListIcon fontSize="small" value="foo" data-module="bar" />,
        });
      }
      if (creds.modules.indexOf("Requirements") >= 0) {
        pages.current.push({
          name: "Requirements",
          icon: <CheckBoxIcon fontSize="small" />,
        });
      }
      if (creds.modules.indexOf("Change Log") >= 0) {
        pages.current.push({
          name: "Change Log",
          icon: <ChangeCircleIcon fontSize="small" />,
        });
      }
      /*if (ganttEnabled) {
        pages.current = [
          ...pages.current,

          {
            name: "Dashboard",
            icon: <DashboardIcon fontSize="small" />,
          },
          { name: "Gantt", icon: <SegmentIcon fontSize="small" /> },
          { name: "Messages", icon: <MessageIcon fontSize="small" /> },
          {
            name: "RAID",
            icon: <ListIcon fontSize="small" value="foo" data-module="bar" />,
          },
          { name: "Requirements", icon: <CheckBoxIcon fontSize="small" /> },
          { name: "Change Log", icon: <ChangeCircleIcon fontSize="small" /> },
        ];
      } else {
        pages.current = [
          ...pages.current,
          {
            name: "Dashboard",
            icon: <DashboardIcon fontSize="small" />,
          },
          { name: "Messages", icon: <MessageIcon fontSize="small" /> },
          { name: "RAID", icon: <ListIcon fontSize="small" /> },
          { name: "Requirements", icon: <CheckBoxIcon fontSize="small" /> },
          { name: "Change Log", icon: <ChangeCircleIcon fontSize="small" /> },
        ];
      }
      if (loadedSettings && loadedSettings.showWhiteboardSetting) {
        pages.current = [
          ...pages.current,
          { name: "Whiteboard", icon: <ShapeLineIcon fontSize="small" /> },
        ];
      }*/
      //console.log(creds.modules);
      raidSubPages.current = [
        { name: "Risks", icon: "e-icons e-warning" },
        {
          name: projectObject.current.oada_project_raid_assumptions__c
            ? "Assumptions"
            : "Actions",
          icon: "e-icons e-star-filled",
        },
        { name: "Issues", icon: "e-icons e-table-update" },
        { name: "Decisions", icon: "e-icons e-check-box" },
        { name: "All RAID Items", icon: "e-icons e-menu" },
      ];

      commSubPages.current = [
        { name: "Message Board", icon: "e-icons e-paragraph-2" },
        { name: "Chat", icon: "e-icons e-annotation-edit" },
      ];
      //}
    }

    // determine default page to display based on settings
    let pageToDisplay = creds.modules[0];
    const rawSettingsFromStorage = localStorage.getItem("oadaSettings");
    if (rawSettingsFromStorage && rawSettingsFromStorage != "undefined") {
      const settingsFromStorage = JSON.parse(rawSettingsFromStorage);

      pageToDisplay =
        creds.modules.indexOf(settingsFromStorage.startingDashboardScreen) >= 0
          ? settingsFromStorage.startingDashboardScreen
          : pageToDisplay;
    }
    if (tab >= 0) {
      pageToDisplay = pages.current[tab];
    }
    setTarget(pageToDisplay);
  };

  function setTarget(tempButtonClicked) {
    let buttonClicked;
    if (tempButtonClicked && typeof tempButtonClicked == "object") {
      buttonClicked = tempButtonClicked.name;
    } else {
      buttonClicked = tempButtonClicked;
    }
    //This IF block is needed when browser refresh triggered

    if (!buttonClicked) {
      /*const lastUnloadTime = parseInt(localStorage.getItem("lastUnloadTime"));
      if (lastUnloadTime) {
        const currentTime = new Date().getTime();
        if (currentTime - lastUnloadTime > 10000) {
          // if browser unloaded within 10 seconds of new load, will bring up previous tab, otherwise requires new login
          localStorage.removeItem("currentTab");
        }
      }*/

      buttonClicked = sessionStorage.getItem("currentTab");

      selectedTab.current = sessionStorage.getItem("selectedTabIndex");

      const projObjString = sessionStorage.getItem("projectObject");
      if (projObjString) {
        projectObject.current = JSON.parse(projObjString);
      }

      if (buttonClicked && projectObject.current) {
        refreshDashboard(
          selectedTab.current,
          projectObject.current.id,
          projectObject.current.name,
          projectObject.current.oada_discussion__c,
          metrics.current,
          projectObject.current,
        );
      }
    }

    if (!buttonClicked || buttonClicked == "Login") {
      selectedTab.current = -1;
      projectObject.current = null;
      pages.current = [];
      props.setVisibleScreen(
        <CredentialsPage
          prepPage={prepDisplay}
          setProduct={props.setProduct}
          waitHandler={props.waitHandler}
          product="oacc"
        />,
      );
    } else {
      if (buttonClicked != "Blank") {
        const currentTab = sessionStorage.getItem("currentTab");
        if (currentTab) {
          const tabHistory = sessionStorage.getItem("tabHistory");
          if (tabHistory) {
            const tabHistoryArray = tabHistory.split(",");
            if (currentTab != tabHistoryArray[tabHistoryArray.length - 1]) {
              sessionStorage.setItem(
                "tabHistory",
                tabHistory + "," + currentTab,
              );
            }
          } else {
            sessionStorage.setItem("tabHistory", currentTab);
          }
        }

        sessionStorage.setItem("currentTab", buttonClicked);
        // the names here must match the values of the multiselect oada_modules__c field

        switch (buttonClicked) {
          case "Dashboard":
            selectedTab.current = creds.modules.indexOf("Dashboard") + 1;
            break;
          case "Gantt":
            selectedTab.current = creds.modules.indexOf("Gantt Chart") + 1;
            break;
          case "Communication":
          case "Messages":
          case "Discussion":
            selectedTab.current = creds.modules.indexOf("Messages") + 1;
            break;
          case "RAID":
            selectedTab.current = creds.modules.indexOf("RAID") + 1;
            break;
          case "Requirements":
            selectedTab.current = creds.modules.indexOf("Requirements") + 1;
            break;
          case "Change Log":
            selectedTab.current = creds.modules.indexOf("Change Log") + 1;
            break;
          case "Whiteboard":
            selectedTab.current = creds.modules.indexOf("Whiteboard") + 1;
            break;
          case "Blank":
            selectedTab.current = 100;
            break;
        }
        sessionStorage.setItem("selectedTabIndex", selectedTab.current);
      }

      if (buttonClicked == "RAID") {
        buttonClicked = sessionStorage.getItem("selectedRaidSubtab") || "Risks";
      }
      switch (buttonClicked) {
        case "Risks":
          selectedRaidSubTab.current = 0;
          break;
        case "Assumptions":
        case "Actions":
          selectedRaidSubTab.current = 1;
          break;
        case "Issues":
          selectedRaidSubTab.current = 2;
          break;
        case "Decisions":
          selectedRaidSubTab.current = 3;
          break;
        case "All RAID Items":
          selectedRaidSubTab.current = 4;
          break;
      }

      if (buttonClicked == "Communication") {
        buttonClicked = sessionStorage.getItem("selectedCommSubtab") || "Chat";
      }
      switch (buttonClicked) {
        case "Message Board":
          selectedCommSubTab.current = 0;
          break;
        case "Chat":
          selectedCommSubTab.current = 1;
          break;
      }

      if (buttonClicked == "Projects") {
        const rawFavorites = localStorage.getItem(
          creds.company + "|FavoriteProjects",
        );
        if (
          creds.userType != "generic" &&
          (!rawFavorites || rawFavorites == "[]")
        ) {
          props.waitHandler(false);

          setShowNoFavoritesDialog(true);
        } else {
          selectedTab.current = 0;
          projectObject.current = null;
          props.setVisibleScreen(
            projectList.current == "button0" ? (
              <DashboardAllProjects
                onClick={refreshDashboard}
                waitHandler={props.waitHandler}
              />
            ) : (
              <DashboardAllProjects_ff
                onClick={refreshDashboard}
                waitHandler={props.waitHandler}
              />
            ),
          );
          //props.setVisibleScreen(<InvoiceBulkSendContainer />);
        }
      }

      if (buttonClicked == "Dashboard") {
        selectedTab.current = 1;
        /*props.setVisibleScreen(
          <DashboardSingleProject
            //projectObject={projectObject.current}
            waitHandler={props.waitHandler}
          />,
        );*/
        props.setVisibleScreen(
          <DashboardSingleProject_nogrid waitHandler={props.waitHandler} />,
        );
      }
      if (buttonClicked == "Gantt") {
        //selectedTab.current = 2;
        props.setVisibleScreen(
          <GanttChartContainer
            projectObject={projectObject.current}
            waitHandler={props.waitHandler}
          />,
        );
      }
      if (buttonClicked == "Messages") {
        props.setVisibleScreen(
          <Discussion
            discussionThread={discussion.current}
            waitHandler={props.waitHandler}
            refreshDashboard={refreshDashboard}
            projectObject={projectObject.current}
          />,
        );
      }
      if (buttonClicked == "Requirements") {
        props.setVisibleScreen(
          <RequirementsContainer
            waitHandler={props.waitHandler}
            projectObject={projectObject.current}
            openSettings={openGlobalSettings}
          />,
        );
      }

      if (buttonClicked == "Change Log") {
        //showChangeLogHeader.current = false;
        props.setVisibleScreen(
          <ChangeLogContainer
            projectObject={projectObject.current}
            waitHandler={props.waitHandler}
          />,
        );
      }

      if (buttonClicked == "Whiteboard") {
        //showChangeLogHeader.current = false;
        props.setVisibleScreen(
          <TLDrawComponent
            projectObject={projectObject.current}
            waitHandler={props.waitHandler}
          />,
        );
        //props.setVisibleScreen(<TimeEntry waitHandler={props.waitHandler} />);
      }
      if (buttonClicked == "Blank") {
        //selectedTab.current = 100;
        props.setVisibleScreen(<BlankScreen />);
      }

      if (buttonClicked == "Risks") {
        sessionStorage.setItem("selectedRaidSubtab", "Risks");
        props.setVisibleScreen(
          <RAIDContainer
            waitHandler={props.waitHandler}
            projectObject={projectObject.current}
            openSettings={openGlobalSettings}
            raidType="risk"
          />,
        );
      }
      if (buttonClicked == "Assumptions") {
        sessionStorage.setItem("selectedRaidSubtab", "Assumptions");
        props.setVisibleScreen(
          <RAIDContainer
            waitHandler={props.waitHandler}
            projectObject={projectObject.current}
            openSettings={openGlobalSettings}
            raidType="assumption"
          />,
        );
      }
      if (buttonClicked == "Actions") {
        sessionStorage.setItem("selectedRaidSubtab", "Actions");
        props.setVisibleScreen(
          <RAIDContainer
            waitHandler={props.waitHandler}
            projectObject={projectObject.current}
            openSettings={openGlobalSettings}
            raidType="action"
          />,
        );
      }
      if (buttonClicked == "Issues") {
        sessionStorage.setItem("selectedRaidSubtab", "Issues");
        props.setVisibleScreen(
          <RAIDContainer
            waitHandler={props.waitHandler}
            projectObject={projectObject.current}
            openSettings={openGlobalSettings}
            raidType="issue"
          />,
        );
      }
      if (buttonClicked == "Decisions") {
        sessionStorage.setItem("selectedRaidSubtab", "Decisions");
        props.setVisibleScreen(
          <RAIDContainer
            waitHandler={props.waitHandler}
            projectObject={projectObject.current}
            openSettings={openGlobalSettings}
            raidType="decision"
          />,
        );
      }
      if (buttonClicked == "All RAID Items") {
        sessionStorage.setItem("selectedRaidSubtab", "All RAID Items");
        props.setVisibleScreen(
          <RAIDContainer
            waitHandler={props.waitHandler}
            projectObject={projectObject.current}
            openSettings={openGlobalSettings}
            raidType="all"
          />,
        );
      }
      if (buttonClicked == "Message Board" || buttonClicked == "Discussion") {
        sessionStorage.setItem("selectedCommSubtab", "Message Board");
        props.setVisibleScreen(
          <Discussion
            discussionThread={discussion.current}
            waitHandler={props.waitHandler}
            refreshDashboard={refreshDashboard}
            projectObject={projectObject.current}
          />,
        );
      }
    }
  }
  /*
  useEffect(() => {
    if (creds) {
      if (creds.client) {
        const urlString = Tools.getInstanceUrl(creds);
        const authString = Tools.getXmlBodyAuthString(creds);
        const requestString =
          authString +
          '<Read type="Customer" method="equal to" limit="1" enable_custom="1"><Customer><id>' +
          creds.client +
          "</id></Customer></Read></request>";
        Tools.fetchPost(requestString, urlString, "Customer").then(
          (rawCustRec) => {
            const custRecArray = Tools.xmlToArray(rawCustRec.xml);
            const reportIds = custRecArray[0].oada_report_ids__c;
            localStorage.setItem("reportIds", reportIds);
          },
        );
      }
    }
  }, [creds.client]);
*/
  useEffect(() => {
    const queryParameters = new URLSearchParams(window.location.search);
    let targetSet = false;
    queryParameters.forEach((value, key) => {
      if (key == "target") {
        targetSet = true;
        setTarget(value);
      }
    });
    if (!targetSet) {
      setTarget("");
    }
  }, []);

  const handleSettingsClick = () => {
    setTarget("Blank");
    setOpen(true);
  };

  const openGlobalSettings = () => {
    settingsPage.current = "SPP Instance Settings";
    setOpen(true);
  };

  const redirectToSettings = () => {
    setShowNoFavoritesDialog(false);
    setOpen(true);
  };
  //const settingsContent = <SettingsContainer />;

  const tooltipText = [
    {
      name: "Projects",
      text: "List of the projects in the Favorites list as configured in the Settings",
    },
    {
      name: "Dashboard",
      text: "Dashboard widgets specific to the current project as configured in the Settings in the Dashboard Settings section",
    },
    { name: "Gantt", text: "Gantt Chart for this project" },
    {
      name: "Communication",
      text: "Message Board and Chat threads for this project",
    },
    {
      name: "Messages",
      text: "Message Board for this project",
    },
    {
      name: "RAID",
      text: "Logs of Risks, Assumptions/Actions, Issues, and Decisions for this project",
    },
    {
      name: "Requirements",
      text: "Individual trackable requirements for this project",
    },
    {
      name: "Change Log",
      text: "List of changes to selected fields on Tasks, RAID items, and Requirements for this project",
    },
    {
      name: "Whiteboard",
      text: "Whiteboard for drawings, images, etc. for this project",
    },
  ];

  sessionStorage.setItem("panelsLocked", panelsLocked);
  const togglePanelsLocked = (event) => {
    setAddPanelAnchorElem(event.currentTarget);
    setPanelsLocked(!panelsLocked);
    handleClick(event);
  };
  const panelsLockedColor = panelsLocked ? "#643f69" : "red";
  const panelsLockedIcon = panelsLocked ? (
    <LockIcon></LockIcon>
  ) : (
    <LockOpenIcon></LockOpenIcon>
  );

  const handleAddPanelClick = (event) => {
    setShowAddPanel(true);
  };

  const handleProjectListClick = (event) => {
    projectList.current = event.currentTarget.id;
    setTarget("Projects");
  };

  return (
    <>
      <CustomAlert
        alertText={errorMessage.current}
        openAlert={openAlert}
        setOpenAlert={setOpenAlert}
        backgroundColor="crimson"
      />
      <Box sx={{ width: "98vw", display: "flex" }}>
        <AppBar sx={{ size: "small" }}>
          <Toolbar
            variant="dense"
            sx={{ minHeight: 48, height: 48, backgroundColor: "#154360" }}
          >
            <Tooltip
              className="moduleTooltip"
              key={"mainLogoWithVersion"}
              placement="bottom-start"
              arrow
              enterDelay={1500}
              leaveDelay={200}
              title={<Typography>Version 1.2 build 7</Typography>}
            >
              <img
                id="Login"
                onClick={handleClick}
                style={{
                  width: "110px",
                  height: "32px",
                  cursor: "pointer",
                  marginRight: "10px",
                }}
                src="./collabcenter_stacked_with_plus.png"
              ></img>
            </Tooltip>
            <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}>
              {projectListButtons.map((header, tabIndex) => (
                <Button
                  id={"button" + tabIndex}
                  key={"button" + tabIndex}
                  onClick={handleProjectListClick}
                  sx={{
                    borderRadius: "15px",
                    marginLeft: "30px",
                    color: "white",
                    backgroundColor:
                      projectList.current == "button" + tabIndex
                        ? "#643f69"
                        : "",
                  }}
                >
                  {header}
                </Button>
              ))}

              {pages.current.map((page, pageIndex) => (
                <Tooltip
                  className="moduleTooltip"
                  key={page.name + pageIndex}
                  placement="bottom-start"
                  arrow
                  enterDelay={1500}
                  leaveDelay={200}
                  title={
                    (page.name == "Requirements" || page.name == "RAID") &&
                    projectObject.current.oada_project_team__c == "" ? (
                      <Typography>
                        This tab is disabled because the project team is empty.
                        Use the Project Team widget on the dashboard to add team
                        members.
                      </Typography>
                    ) : (
                      tooltipText.find((elem) => elem.name == page.name).text
                    )
                  }
                >
                  <span>
                    <Button
                      className="collabButton"
                      id={"collabToolbar_" + page.name}
                      value={page.name}
                      onClick={handleClick}
                      sx={{
                        backgroundColor:
                          selectedTab.current == pageIndex ? "steelblue" : "",
                      }}
                      disabled={
                        (page.name == "Requirements" || page.name == "RAID") &&
                        projectObject.current.oada_project_team__c == ""
                      }
                    >
                      <Stack
                        direction="row"
                        alignItems="center"
                        gap={0.5}
                        className="collabButtonText"
                      >
                        {page.icon}
                        {page.name}
                      </Stack>
                    </Button>
                  </span>
                </Tooltip>
              ))}
            </Box>
            <Box display="flex">
              {selectedTab.current == 7 ? (
                <Box
                  ref={containerRef}
                  sx={{
                    backgroundColor: panelsLockedColor,
                    margin: "6px",
                    borderRadius: "10px",
                    fontSize: "14px",
                    padding: "3px 10px 0px 10px",
                  }}
                >
                  {panelsLocked ? null : (
                    <IconButton
                      onClick={handleAddPanelClick}
                      sx={{ color: "white" }}
                    >
                      <AddCardIcon />
                    </IconButton>
                  )}

                  <IconButton
                    sx={{ color: "white" }}
                    onClick={togglePanelsLocked}
                  >
                    {panelsLockedIcon}
                  </IconButton>
                </Box>
              ) : null}
              {creds /*&& projectObject.current*/ ? (
                <IconButton
                  id="__collabToolbarSettings"
                  onClick={helpMode ? null : handleSettingsClick}
                  sx={{ color: "white" }}
                >
                  <SettingsIcon />
                </IconButton>
              ) : (
                <></>
              )}
            </Box>
          </Toolbar>
          {selectedTab.current > 0 &&
          selectedTab.current == creds.modules.indexOf("RAID") + 1 ? (
            <Toolbar
              variant="dense"
              sx={{
                minHeight: 48,
                height: 48,
                backgroundColor: "darkslategray",
              }}
            >
              <Box
                sx={{
                  justifyContent: "center",
                  flexGrow: 1,
                  display: { xs: "none", md: "flex" },
                }}
              >
                {raidSubPages.current.map((subpage, subpageIndex) => (
                  <Button
                    className="collabSubButton"
                    key={subpage.name + subpageIndex}
                    value={subpage.name}
                    onClick={handleClick}
                    sx={{
                      backgroundColor:
                        selectedRaidSubTab.current == subpageIndex
                          ? "green"
                          : "",
                    }}
                  >
                    <span
                      className={subpage.icon}
                      style={{ padding: "0px 5px" }}
                    ></span>
                    {subpage.name}
                  </Button>
                ))}
              </Box>
            </Toolbar>
          ) : null}
          {selectedTab.current == 300 ? (
            <Toolbar
              variant="dense"
              sx={{
                minHeight: 48,
                height: 48,
                backgroundColor: "darkslategray",
              }}
            >
              <Box
                sx={{
                  justifyContent: "center",
                  flexGrow: 1,
                  display: { xs: "none", md: "flex" },
                }}
              >
                {commSubPages.current.map((subpage, subpageIndex) => (
                  <Button
                    className="collabSubButton"
                    key={subpage.name + subpageIndex}
                    value={subpage.name}
                    onClick={handleClick}
                    sx={{
                      backgroundColor:
                        selectedCommSubTab.current == subpageIndex
                          ? "green"
                          : "",
                    }}
                  >
                    <span
                      className={subpage.icon}
                      style={{ padding: "0px 5px" }}
                    ></span>
                    {subpage.name}
                  </Button>
                ))}
              </Box>
            </Toolbar>
          ) : null}
        </AppBar>
      </Box>
      <Dialog open={open} fullScreen>
        <DialogTitle
          id="alert-dialog-title_cc"
          className="settingsDialogClass"
          data-dashboardsetuplocked={dashboardsetuplocked}
          sx={{ color: "white" }}
        >
          <DialogActions>
            <Button
              onClick={handleSave}
              value="close"
              autoFocus
              className="dialogConfirmCancelButton"
            >
              Close
            </Button>
          </DialogActions>
        </DialogTitle>

        <DialogContent
          className="settingsDialogClass"
          data-dashboardsetuplocked={dashboardsetuplocked}
        >
          <SettingsContainer
            setTarget={setTarget}
            setLock={setDashboardSetupLocked}
            handleClose={handleSave}
            projectObject={projectObject.current}
            settingsPage={settingsPage.current}
          />
        </DialogContent>
      </Dialog>
      <Dialog open={showNoFavoritesDialog}>
        <DialogContent sx={{ overflow: "hidden", padding: "0px" }}>
          <Alert
            variant="filled"
            //onClose={handleConfirmationClose}
            severity="info"
            sx={{
              width: "100%",
              fontSize: "large",
              padding: "5px",
            }}
          >
            <Typography sx={{ padding: "15px" }}>
              You have not yet configured your list of projects to view. Click
              &quot;OK&quot; to go to the Settings page to set up this list.
            </Typography>
            <DialogActions sx={{ paddingRight: "30px" }}>
              <Button
                className="settingsButtonActive"
                variant="filled"
                value="OK"
                onClick={redirectToSettings}
                sx={{ margin: "0px !important" }}
              >
                OK
              </Button>
            </DialogActions>
          </Alert>
        </DialogContent>
      </Dialog>
    </>
  );
}

export default CollaborationCompanionToolbar;

CollaborationCompanionToolbar.propTypes = {
  waitHandler: PropTypes.func,
  retrieveOADASettings: PropTypes.func,
  setVisibleScreen: PropTypes.func,
  creds: PropTypes.object,
  setProduct: PropTypes.func,
};

/*
            <Button
              onClick={handleCancel}
              value="cancel"
              autoFocus
              className="dialogConfirmCancelButtonWide"
              sx={{ marginRight: "50px" }}
            >
              Close without Saving
            </Button>
*/

/*
      <Box>
        <Typography variant="h6" className="settingsBoxTitle">
          &nbsp;&nbsp;User Preferences&nbsp;&nbsp;
        </Typography>
        <Box className="settingsBox">
          <SettingsStartingPage handleSettingsChange={handleSettingsChange} />
          <SettingsStartingDashboardPage
            handleSettingsChange={handleSettingsChange}
          />
          <SettingsAssociatedClient
            handleSettingsChange={handleSettingsChange}
          />
        </Box>
      </Box>
      */

/*
            if (buttonClicked == "Analysis") {
        selectedTab.current = 5;
        props.setVisibleScreen(
          <AnalysisContainer
            projectid={projid.current}
            projectname={projname.current}
            waitHandler={props.waitHandler}
          />,
        );
      }*/
